import React from 'react';
import { Col, Row } from 'react-bootstrap';
import cx from 'classnames';
import SummaryPremiumRow from '../SummaryPremiumRow/SummaryPremiumRow';
import displayCurrency from '../../../../../helpers/displayCurrency';
import './MtaPremiumSummary.scss';
import BenefitsModal from '../../BenefitsModal/BenefitsModal';
import PremiumBreakdown from '../../PremiumBreakdown/PremiumBreakdown';

const MtaPremiumSummary = ({ premium, isMta, scheme, benefits, taxRate, payable }) => {
  if (!isMta || !premium) {
    return null;
  }
  const title = payable ? 'New Premium ' : 'Original Premium ';
  const { discount } = premium;
  const premiumTypeTitle =
    !!payable && payable.premium.gross < 0 ? 'Return Premium' : 'Additional Premium';

  return (
    <Col md={12} className="bottom-bar">
      <div
        className={cx(' mta-premium-summary', {
          payable: !!payable,
        })}
      >
        <Row>
          <Col md={12}>
            {title}
            <BenefitsModal scheme={scheme} benefits={benefits} />
          </Col>
        </Row>
        <Row>
          <Col md={12}>{scheme.name}</Col>
        </Row>

        <SummaryPremiumRow
          label={'Base Premium'}
          value={displayCurrency(premium.principal)}
        />

        <SummaryPremiumRow
          label={'Discount'}
          value={discount ? displayCurrency(discount) : null}
        />

        <SummaryPremiumRow
          label={`IPT (${taxRate || 0}%)`}
          value={displayCurrency(premium.tax || 0)}
        />

        <SummaryPremiumRow
          label={'Admin Fees'}
          value={displayCurrency(premium.ex_tax || 0)}
        />
        <SummaryPremiumRow
          label={'Total Payable'}
          value={displayCurrency(premium.gross)}
        />
        <SummaryPremiumRow
          label={premiumTypeTitle}
          value={
            payable ? (
              <>
                <PremiumBreakdown
                  premium={payable}
                  className="small-premium"
                  showIpt={false}
                />
              </>
            ) : null
          }
        />
      </div>
    </Col>
  );
};
export default MtaPremiumSummary;
